/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Callcount1Inputs */

const zh_analytics_callcount1 = /** @type {(inputs: Analytics_Callcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调用次数`)
};

const en_analytics_callcount1 = /** @type {(inputs: Analytics_Callcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls`)
};

const es_analytics_callcount1 = /** @type {(inputs: Analytics_Callcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llamadas`)
};

/**
* | output |
* | --- |
* | "Calls" |
*
* @param {Analytics_Callcount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_callcount1 = /** @type {((inputs?: Analytics_Callcount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Callcount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_callcount1(inputs)
	if (locale === "en") return en_analytics_callcount1(inputs)
	return es_analytics_callcount1(inputs)
});
export { analytics_callcount1 as "analytics_callCount" }